import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, shopping_cart_session_id, KImageURL, DefaultImage, GetShoppingCart, UpdateShoppingCart } from "../GlobalScript";
import { ShoppingCartContext } from '../dealer/ShoppingCartContext';
import Cookies from 'js-cookie';
import Select from 'react-select';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer';

export default function Item() {

    const navigate = useNavigate();
    const location = useLocation();
    const { vehicle, model, year, item, level1, level2, level1Name, level2Name, keywords } = location.state || {};
    const [loading, setLoading] = useState(true);
    const [imageLoad, setImageLoad] = useState(false);
    const [itemSizeLoad, setItemSizeLoad] = useState(false);
    const [itemLoad, setItemLoad] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [masterItem, setMasterItem] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showModelModal, setShowModelModal] = useState(false);
    const [selectedItemForModels, setSelectedItemForModels] = useState(null);
    const [models, setModels] = useState(null);
    const [addImages, setAddImages] = useState(null);
    const [newImage, setNewImage] = useState('');
    const [largeImage, setLargeImage] = useState('');
    const [imageModal, setImageModal] = useState(false);
    const [apparel, setApparel] = useState(false);
    /*    const [size, setSize] = useState(null);*/
    const [itemSizes, setItemSizes] = useState(new Map());
    const [qtys, setQtys] = useState({});
    const [pop, setPop] = useState(false);
    const { shoppingCart, setShoppingCart, setDropdownOpen } = useContext(ShoppingCartContext);
    const [itemsInfoFromAPI, setItemsInfoFromAPI] = useState(new Map());//save itemNumber, statusicon, prices to impove user experience
    const [selectedItem, setSelectedItem] = useState(new Map());
    const [showAvailability, setShowAvailability] = useState(false);
    const [popUpModal, setPopUpModal] = useState(false);
    const [popUpErrorMsg, setPopUpMsg] = useState('');
    const [quickAdd, setQuickAdd] = useState(true);
    const [addInfo, setAddInfo] = useState(null);
    const [itemAvailability, setItemAvailability] = useState(null);
    const [isDealer, setIsDealer] = useState(true);

    useEffect(() => {
        if (window.location.origin.indexOf("kdealer") > -1 || window.location.origin.indexOf("k-dealer") > -1) {
            document.title = 'K-Dealer - Item';
        } else if (window.location.origin.indexOf("kcountries") > -1 || window.location.origin.indexOf("k-countries") > -1) {
            document.title = 'K-Countries - Item';
        } else if (window.location.origin.indexOf("localhost") > -1) {
            document.title = 'K-Dealer - Item';
        }
    }, []);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            #root > div > div {
                background-color: #fff;
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style); // Clean up when unmounting
        };
    });

    useEffect(() => {
        const cart = GetShoppingCart(shoppingCart);
        setShoppingCart(cart);
        GetImages();
        GetItemSizes();
        //if (loading && item) {
        //    GetSKUDetail(null, false);
        //}
    }, [location])

    const handlePopUpModalShow = () => {
        setPopUpModal(true);
    }
    const handlePopUpModalClose = () => {
        setPopUpModal(false);
        setPopUpMsg('');
    }

    useEffect(() => {
        if (loading) {
            handlePop();
        } else {
            handleClosePop();
        }
    }, [loading])

    useEffect(() => {
        if (itemSizeLoad || imageLoad || itemLoad) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [itemSizeLoad, imageLoad, itemLoad, masterItem])

    const timeoutRef = useRef(null);

    const handleImageModalShow = () => setImageModal(true);
    const handleImageModalHide = () => setImageModal(false);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    //Leave modal code just in case we add one later to this page
    const handleDetailsModalShow = () => {
        setShowDetailsModal(true);
    }
    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
    }

    const handleModelModalShow = (itemNum) => {
        GetModels(itemNum);
        setShowModelModal(true);
    }
    const handleModelModalClose = () => setShowModelModal(false);

    const GetModels = async (itemnum) => {
        CheckSession();
        const response = await fetch("kdealer/GetModels/" + itemnum);
        if (response.status !== 200) {
            return;
        }
        const js = await response.json();
        const grouped = Object.groupBy(js.models, ({ year }) => year);
        const sortedGroups = Object.entries(grouped)
            .sort(([groupA], [groupB]) => groupB.localeCompare(groupA))
            .map(([group, models]) => {
                models.sort((a, b) => a.label - b.label);
                return { group, models };
            });
        setSelectedItemForModels({ itemNum: js.itemNum, itemName: js.itemName })
        console.log(sortedGroups);
        setModels(sortedGroups);
    }

    const GetImages = async () => {
        if (!item) {
            return;
        }
        setImageLoad(true);
        CheckSession();
        const data = {
            value: item.itemNumber,
            label: item.img
        }
        const rqst = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch('catalog/GetItemImages/', rqst);
        if (response.status !== 200) {
            setImageLoad(false);
            return;
        }
        const lst = await response.json();
        setAddImages(lst);
        setImageLoad(false);
    }

    const GetItemSizes = async () => {
        if (!item) {
            return;
        }
        setItemSizeLoad(true);
        CheckSession();
        const user = GetCoockie();
        const data = {
            label: user.dealerID,
            value: item.itemNumber
        };
        const rqst = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch('catalog/GetItemSizes/', rqst);
        if (response.status !== 200) {
            setItemSizeLoad(false);
            throw new Error(response.statusText);
        }
        //const response = await fetch('catalog/GetItemSizes/' + item.itemNumber);
        //if (response.status !== 200) {
        //    setItemSizeLoad(false);
        //    return;
        //}
        const lst = await response.json();
        //console.log(lst);
        const map = new Map();
        lst.forEach((element) => {
            if (isDealer !== element.isDealer) {
                setIsDealer(element.isDealer);
            }
            map.set(element.itemNumber.replaceAll('-', '').replaceAll(' ',''), element);
        });
        setItemSizes(map);
        const addRes = await fetch('catalog/GetAdditionInfoFromDB/' + item.itemNumber);
        if (addRes.status !== 200) {
            setItemSizeLoad(false);
            return;
        }
        const addInfoRes = await addRes.json();
        setAddInfo(addInfoRes);
        if (addInfoRes && addInfoRes.prodLinesText === "APPAREL") {
            setApparel(true);
        }
        setItemSizeLoad(false);
    }
   
    useEffect(() => {
        if (masterItem) {
            if (masterItem.addInfo && masterItem.addInfo.prodLinesText === "APPAREL") {
                setApparel(true);
            }
            const map = new Map(itemsInfoFromAPI);
            map.set(masterItem.item.distitemNbr, masterItem.item);
            setItemsInfoFromAPI(map);
            setSelectedItem(masterItem.item);
        }       
    }, [masterItem])

    //useEffect(() => {
    //    if (!masterItem) {
    //        setItemLoad(true);
    //        timeoutRef.current = setTimeout(() => {
    //            setItemLoad(false);
    //            setPopUpMsg('There was an issue connecting to the Kawasaki server. Please try again later');
    //            handlePopUpModalShow();
    //        }, 20000);
    //    } else {
    //        clearTimeout(timeoutRef.current);
    //        setItemLoad(false);
    //    }

    //    return () => clearTimeout(timeoutRef.current);
    //}, [masterItem])

    const changeImage = (img) => {
        setNewImage(img);
    }

    const enlargeImage = (img) => {
        setLargeImage(img);
        handleImageModalShow();
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'quantity') {
            setQuantity(value);
        }
    }

    const returnCatalog = () => {
        navigate('/catalog', { state: { vehicle: vehicle, model: model, year: year, level1: level1, level2: level2, level1Name: level1Name, level2Name: level2Name, keywords: keywords } });
    }

    const addToCart = () => {
        //Add to cart
        if (itemSizes?.size > 0) {
            const itemsToAdd = Array.from(itemSizes.entries())
                .filter(([sku]) => qtys[sku] > 0)
                .map(([sku, item]) => ({
                    ...item,
                    itemNumber: sku,
                    qty: qtys[sku]
                }));

            addItemsToCart(itemsToAdd);
        } else if (quickAdd) {
            quickAddCart();
        } else {
            GetSKUDetail(null, true);
        }
    }

    const quickAddCart = async () => {
        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const partNumFormat = masterItem ? selectedItem.distitemNbr.trim() : item.itemNumber.trim();
            const qty = parseInt(quantity);
            if (qty <= 0) {
                return;
            }
            const skuqty = [];
            skuqty.push({
                sku: partNumFormat,
                qty: qty
            });
            const crrMap = new Map();
            let orderType = "1";
            let dealerID = user.dealerID;
            /*const cart = GetShoppingCart();*/
            const cart = GetShoppingCart(shoppingCart);
            if (cart && cart.orderType) {
                orderType = cart.orderType;
            }
            if (cart && cart.dealerID) {
                dealerID = cart.dealerID;
            }
            //const newCart = await GetSKUDetailGlb(skuqty, orderType, orderType, dealerID);
            const arr = [];
            ////update shopping cart:add code bellow
            //if (newCart && newCart.items) {
            //    newCart.items.forEach(element => {
            //        const itmNum = element.item.distitemNbr.replaceAll('-', '');
            //        if (!crrMap.has(itmNum) && element.item.qtyOrdered > 0) {
            //            crrMap.set(itmNum, element);
            //        }
            //    });
            //}
            const crrPartNum = partNumFormat.replaceAll('-', '').replaceAll(' ','');
            if (cart && cart.items) {
                cart.items.forEach(element => {
                    const itmNum = element.item.distitemNbr.replaceAll('-', '');
                    if (!crrMap.has(itmNum) && element.item.qtyOrdered > 0) {
                        if (itmNum === crrPartNum) {
                            let copy = { ...element };
                            copy.item.new = true;
                            copy.item.qtyOrdered = qty;
                            copy.item.qty = qty;
                            crrMap.set(itmNum, copy);
                            arr.push(copy);
                        } else {
                            crrMap.set(itmNum, element);
                            arr.push(element);
                        }

                    }

                });
            }
            //if (crrMap.size > 0 && !crrMap.has(crrPartNum)) {
            //    let obj = crrMap.entries().next().value;
            //    let clone = { ...obj[1]};
            //    clone.item.distitemNbr = partNum;
            //    clone.item.qtyOrdered = qty;
            //    clone.item.qty = qty;
            //    clone.item.new = true;
            //    arr.push(clone);
            //}
            if (crrMap.size === 0 || !crrMap.has(crrPartNum)) {
                const skuqty = {
                    label: user.dealerID,
                    value: crrPartNum,
                };
                const rqst = {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    body: JSON.stringify(skuqty)
                };
                const res = await fetch('kdealer/GetSKUImage/', rqst);
                if (res.status !== 200) {
                    throw new Error(res.statusText);
                }
                const img = await res.text();

                const item = {
                    "item":
                    {
                        "itemStaCode": "1",
                        "distitemNbr": partNumFormat,
                        "warehouseAvailColorR": "G0000002",
                        "warehouseAvailColorD": "G0000002",
                        "warehouseAvailColorL": "G0000002",
                        "dealerPrice": 0,
                        "retailPrice": 0,
                        "whslePkgCnt": 1,
                        "prodOrdCnt": qty,
                        "boCnt": 0,
                        "qty": qty,
                        "qtyOrdered": qty,
                        "factorAlert": false,
                        "errorMsg": "",
                        "inventoryType": "",
                        "inventoryTypeIcon": "",
                        "statusIcon": "",
                        "hazMatCode": "N",
                        "oversizeCode": "N",
                        "substitutedSKU": "",
                        "ltl": false,
                        "pk": false,
                        "memo": "",
                        "new": true
                    },
                    "addInfo": {
                        "itemStaCode": "1",
                        "itemStaIcon": "green-icon",
                        "itemNumber": partNumFormat,
                        "itemStaText": null,
                        "itemDesc": "",
                        "prodLinesText": "",
                        "yearString": "",
                        "eligibleExchangeReturn": "",
                        "dimentions": "",
                        "weightVal": "",
                        "img": img,
                        "returnable": false,
                        "exchangable": false
                    }
                }
                arr.push(item);
            }
            const combinedCart = {
                alerts: cart ? cart.alerts : null,
                items: arr,
                orderName: cart ? cart.orderName : '',
                orderType: orderType,
                shipToDealerID: dealerID
            }
            UpdateShoppingCart(combinedCart, setShoppingCart);
            setDropdownOpen(true);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    const switchCartMethod = () => {
        setQuickAdd(false);
        GetSKUDetail(null, false);
    }

    const GetSKUDetail = async (itemNumSelected, addToCart) => {
        try {
            const arr = [];

            if (itemSizes.size > 0) {
                for (const [key, value] of Object.entries(qtys)) {
                    arr.push({ sku: key, qty: value });
                }
            } else {
                $('input[id^="qty-"]').each(function () {
                    var elementId = $(this).attr('id').replace('qty-', '').replaceAll('-', '').replace(' ', ''); // Get the ID of the current input
                    var elementValue = $(this).val();   // Get the value of the current input
                    const qty = parseInt(elementValue);

                    if (qty > 0) {
                        arr.push({ sku: elementId, qty: qty });
                    }
                });
            }

            console.log(arr)

            if (itemSizes.size > 0 && arr.length === 0) {
                setPopUpMsg('Please enter a quantity value for the item(s) you wish to check availability for.');
                handlePopUpModalShow();
                return;
            }

            //const itemNumber = itemNumSelected ? itemNumSelected : (masterItem ? masterItem.item.distitemNbr : item.itemNumber);

            CheckSession();
            const user = GetCoockie();
            handlePop();
            const skuqty = {
                valueLabels: arr,
                orderType: "1",
                dealerID: user.dealerID
            };
            console.log(skuqty)
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(skuqty)
            };
            const res = await fetch('kdealer/GetSkuInfo/', rqst);
            if (res.status !== 200) {
                throw new Error(res.statusText);
            }
            const js = await res.json();
            const addInfo = new Map();
            const newSkuQty = [];
            const arrSubs = [];
            let errorSet = new Set();
            let alertFactor = 0, boCount = 0;
            let LTL = false;
            let pk = false;
            console.log(js);
            let unavailable = false;
            js.map((item) => {
                if (item.distitemNbr !== "") {
                    newSkuQty.push({
                        sku: item.distitemNbr,
                        qty: item.qty
                    }
                    );
                    if (item.substitutedSKU !== "") {
                        arrSubs.push(`${item.substitutedSKU} is substituted by ${item.distitemNbr}`);
                    }
                    if (item.factorAlert) {
                        alertFactor++;
                    }
                    if (item.boCnt > 0) {
                        boCount++;
                    }
                    if (item.ltl === true) {
                        LTL = true;
                    }
                    if (item.pk === true) {
                        pk = true;
                    }
                    if (item.itemStaCode === "4") {
                        item.qty = 0;
                        unavailable = true;
                    }
                }
                if (item.errorMsg !== "") {
                    if (item.errorMsg.toLowerCase().indexOf("invalid") > -1) {
                        errorSet.add("At least one Item Number is invalid.");
                    } else {
                        errorSet.add(item.errorMsg);
                    }
                }
                return '';
            });
            //Item Number
            const skuqty2 = {
                valueLabels: newSkuQty,
                orderType: "1",
                dealerID: user.dealerID
            };
            const rqst2 = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(skuqty2)
            };
            const res2 = await fetch('kdealer/GetSkuInfo2/', rqst2);
            if (res2.status !== 200) {
                throw new Error(res.statusText);
            }
            const js2 = await res2.json();

            js2.map((item) => {
                if (item.itemStaCode === "1") {
                    addInfo.set(item.itemNumber, item);
                }
                return '';
            });
            let skuObjs = [];
            js.map((item) => {
                setIsDealer(item.isDealer);
                if (item.distitemNbr !== "") {
                    const info = {
                        item: item,
                        addInfo: addInfo.get(item.distitemNbr.replaceAll('-', '').replaceAll(' ', ''))
                    }
                    skuObjs.push(info);
                    if (skuObjs[0].addInfo.prodLinesText === "APPAREL") {
                        setApparel(true);
                    }
                    setMasterItem(skuObjs[0]);
                }
                return '';
            });
            setItemAvailability(skuObjs);
            if (addToCart && !unavailable) {
                const alerts = [
                    alertFactor > 0 && { type: 'packQuantity' },
                    boCount > 0 && { type: 'backorder' },
                    LTL && { type: 'ltlShipping' },
                    pk && { type: 'packageBuilt' },
                    arrSubs.length > 0 && { type: 'substitutions' }
                ].filter(Boolean);
                const cart = GetShoppingCart(shoppingCart);
                const crrMap = new Map();
                const arr = [];
                skuObjs.forEach(element => {
                    if (element.item.itemStaCode === "1" || element.item.itemStaCode === "2") {
                        crrMap.set(element.item.distitemNbr, element);
                    }

                });
                if (cart && cart.items) {
                    cart.items.forEach(element => {
                        if (!crrMap.has(element.item.distitemNbr)) {
                            arr.push(element);
                        }

                    });
                }

                let newCartItems = skuObjs;
                if (arr.length > 0) {
                    newCartItems.push(...arr);
                }
                const newCart = {
                    alerts: alerts,
                    items: newCartItems,
                    orderName: '',
                    orderType: "1",
                    shipToDealerID: user.dealerID
                }
                UpdateShoppingCart(newCart, setShoppingCart);
                setDropdownOpen(true);
            } else {
                if (loading || itemNumSelected) {
                    setLoading(false);
                    setShowAvailability(false);
                } else {
                    setShowAvailability(true);
                }
            }
        } catch (error) {
            console.log(error);
            setPopUpMsg('There was an issue connecting to the Kawasaki server. Please try again later');
            handlePopUpModalShow();
        } finally {
            handleClosePop();
        }
    }

    const addItemsToCart = async (items) => {
        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const cart = GetShoppingCart(shoppingCart);
            const crrMap = new Map();
            let orderType = cart?.orderType || "1";
            let dealerID = cart?.dealerID || user.dealerID;
            if (cart && cart.items) {
                for (const element of cart.items) {
                    const itmNum = element?.item?.distitemNbr?.replaceAll('-', '').replaceAll(' ', '') ?? '';
                    crrMap.set(itmNum, element);
                }
            }
            for (const item of items) {
                const partNum = item.itemNumber.replaceAll('-', '').replaceAll(' ', '');
                console.log(partNum)
                const qty = item.qty ?? 1;

                if (cart?.items) {
                    for (const element of cart.items) {
                        const itmNum = element?.item?.distitemNbr?.replaceAll('-', '').replaceAll(' ', '') ?? '';
                        if (element.item.qtyOrdered > 0 && itmNum === partNum) {
                            const copy = { ...element };
                            copy.item.new = true;
                            copy.item.qtyOrdered = qty;
                            copy.item.qty = qty;
                            crrMap.set(itmNum, copy);
                            break;
                        }
                    }
                }

                if (!crrMap.has(partNum.replaceAll('-', '').replaceAll(' ', ''))) {
                    const skuqty = {
                        label: user.dealerID,
                        value: partNum,
                    };
                    const rqst = {
                        method: 'POST',
                        headers: { 'Content-type': 'application/json' },
                        body: JSON.stringify(skuqty),
                    };
                    const res = await fetch('kdealer/GetSKUImage/', rqst);
                    if (res.status !== 200) throw new Error(res.statusText);
                    const img = await res.text();

                    const newItem = {
                        item: {
                            distitemNbr: partNum,
                            qty: qty,
                            qtyOrdered: qty,
                            prodOrdCnt: qty,
                            new: true,
                            itemStaCode: "1",
                            warehouseAvailColorR: "G0000002",
                            warehouseAvailColorD: "G0000002",
                            warehouseAvailColorL: "G0000002",
                            dealerPrice: 0,
                            retailPrice: 0,
                            whslePkgCnt: 1,
                            boCnt: 0,
                            factorAlert: false,
                            errorMsg: "",
                            inventoryType: "",
                            inventoryTypeIcon: "",
                            statusIcon: "",
                            hazMatCode: "N",
                            oversizeCode: "N",
                            substitutedSKU: "",
                            ltl: false,
                            pk: false,
                            memo: ""
                        },
                        addInfo: {
                            itemNumber: partNum,
                            itemStaCode: "1",
                            itemStaIcon: "green-icon",
                            itemDesc: "",
                            img: img,
                            returnable: false,
                            exchangable: false
                        }
                    };
                    crrMap.set(partNum, newItem);
                }
            }
            const arr = Array.from(crrMap.values());
            const combinedCart = {
                alerts: cart ? cart.alerts : null,
                items: arr,
                orderName: cart ? cart.orderName : '',
                orderType,
                shipToDealerID: dealerID
            }

            UpdateShoppingCart(combinedCart, setShoppingCart);
            setDropdownOpen(true);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    const debounceRef = useRef({});

    const handleQtyChange = (e) => {
        const input = e.target.value;
        setQuantity(input);
    }

    const handleQtysChange = (e, key) => {
        const value = Number(e.target.value);

        if (value > 0) {
            setQtys((prev) => ({
                ...prev,
                [key]: value
            }));
        } else {
            setQtys((prev) => {
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });
        }
    }

    const handleQtyBlur = (e) => {
        const id = e.target.id.replace('qty-', '');
        const input = e.target.value.trim();

        clearTimeout(debounceRef.current[id]);

        if (input === '' || parseInt(input) < 1) {
            setQuantity(1);
            return;
        }

        //const raw = ValidateQty(input);
        //const vl = parseInt(raw);

        setQuantity(input);
    }

    const getStatusIcon = (code) => {
        const color = code.charAt(0);
        const number = code.slice(1);

        switch (color) {
            case "G":
                return (
                    <div className="icons-row">
                        <div className="status-icon green-icon"></div>
                        <p>Available</p>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
            case "Y":
                return (
                    <div className="icons-row">
                        <div className="status-icon yellow-icon"></div>
                        <p>Partial</p>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
            default:
                return (
                    <div className="icons-row">
                        <div className="status-icon red-icon"></div>
                        <p>Unavailable</p>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
        }
    };

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row>
                    <Col sm={12}>
                        <p href="/catalog/item#" onClick={returnCatalog} className="black-text heading uppercase clickable underline">
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-left-fill" viewBox="0 0 16 16" role="presentation" style={{ transform: 'rotate(180deg)' }}>
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            Back to Catalog
                        </p>
                    </Col>
                </Row>

                <Row className="mt-5 item-detail-item">
                    <Col lg={4}>
                        <Row>
                            <Col sm={12} className="text-center mb-4">
                                {!newImage ?
                                    <img src={KImageURL(item.itemNumber, item.img)}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = DefaultImage;
                                        }}
                                        alt={item.descr} className="item-detail-image clickable"
                                        onClick={() => enlargeImage(KImageURL(item.itemNumber, item.img))}
                                    />
                                    :
                                    <img src={newImage}
                                        alt={item.descr} className="item-detail-image clickable"
                                        onClick={() => enlargeImage(newImage)}
                                    />
                                }
                            </Col>
                        </Row>

                        <Row className="mt-4 mb-4">
                            <Col sm={3}>
                                <img src={KImageURL(item.itemNumber, item.img)}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = DefaultImage;
                                    }}
                                    alt={item.descr} className="item-detail-image-secondary clickable"
                                    onClick={() => changeImage(KImageURL(item.itemNumber, item.img))}
                                />
                            </Col>

                            {addImages && addImages.map((img, index) => (
                                <Col sm={3} key={index}>
                                    <img src={KImageURL(item.itemNumber, img)}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = DefaultImage;
                                        }}
                                        alt={item.descr} className="item-detail-image-secondary clickable"
                                        onClick={() => changeImage(KImageURL(item.itemNumber, img))}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Col>

                    <Col lg={8}>
                        <Row>
                            <Col sm={12}>
                                <h2 className="heading mb-0">{item.descr}</h2>
                                <p className="smaller-text item-detail-info-row">
                                    {itemSizes.size === 0 && item.itemNumber}
                                    {item.catgory &&
                                        item.catgory.split(',').map((cat, indexCat) => (
                                            <span key={indexCat} className="catalog-item-category">
                                                {cat.trim()}
                                            </span>
                                        ))
                                    } 
                                    {masterItem && <> |<span className="svg-holder small-svg black-text">
                                        <img src={"../../../Images/" + masterItem.item.inventoryTypeIcon} alt={masterItem.item.inventoryTypeIcon} ></img>
                                        {masterItem.item.inventoryTypeIcon === 'accessories.svg' ? 'Accessories' : masterItem.item.inventoryTypeIcon === 'parts.svg' ? 'Parts' : 'Other'}
                                    </span></>}
                                       
                                </p>
                            </Col>
                        </Row>
                        {
                            /*masterItem ?*/
                            <>
                                {itemSizes && itemSizes.size > 0 &&
                                    <Row className="mt-5">
                                        <Col sm={12}>
                                            <Row>
                                                <Col sm={2}>
                                                    <h4 className="heading bold mt-2">SIZE:</h4>
                                                </Col>

                                                <Col sm={10}>
                                                    <Row>
                                                        {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                            <Col key={key + value} className="flex-center">
                                                                <div className={qtys[key] ? "item-product-size active" : "item-product-size"}
                                                                    data-value={key}
                                                                >
                                                                    {value.size}
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm={2}>
                                                    <h4 className="heading bold mt-1">QTY:</h4>
                                                </Col>

                                                <Col sm={10}>
                                                    <Row>
                                                        {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                            <Col key={key} className="flex-center">
                                                                <Form.Control
                                                                    type="number"
                                                                    min="1"
                                                                    step="1"
                                                                    id={`qty-${key}`}
                                                                    aria-describedby="Quantity"
                                                                    className='form-control size-input'
                                                                    onChange={(e) => handleQtysChange(e, key)}
                                                                    value={qtys[key] ?? ''}
                                                                />
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm={2}>
                                                    <h4 className="heading bold mt-1">ITEM NUMBER:</h4>
                                                </Col>

                                                <Col sm={10}>
                                                    <Row className="mt-1">
                                                        {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                            <Col key={key}>
                                                                <p className="smallest-text text-center mt-2">{value.itemNumber}</p>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Col>
                                            </Row>

                                            {isDealer === false &&
                                                <Row>
                                                    <Col sm={2}>
                                                        <h4 className="heading bold mt-3">DISTRIBUTOR PRICE:</h4>
                                                    </Col>

                                                    <Col sm={10}>
                                                        <Row className="mt-2">
                                                            {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                                <Col key={key}>
                                                                    <h4 className="text-center mt-2 heading">{value.price}</h4>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            }

                                            <Row>
                                                <Col sm={2}>
                                                    <h4 className="heading bold mt-3">DEALER PRICE:</h4>
                                                </Col>

                                                <Col sm={10}>
                                                    {isDealer === false ?
                                                        <Row className="mt-2">
                                                            {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                                <Col key={key}>
                                                                    <p className="text-center mt-2">{value.dealerPriceForDistributorDisplayOnly}</p>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                        :
                                                        <Row className="mt-2">
                                                            {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                                <Col key={key}>
                                                                    <h4 className="text-center mt-2 heading">{value.price}</h4>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm={2}>
                                                    <h4 className="heading bold mt-3">MSRP:</h4>
                                                </Col>

                                                <Col sm={10}>
                                                    <Row className="mt-2">
                                                        {Array.from(itemSizes.entries()).map(([key, value]) => (
                                                            <Col key={key}>
                                                                <p className="text-center mt-2">{value.retailPrice}</p>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                }

                                <Row className="mt-4">
                                    {(!itemSizes || itemSizes.size === 0) && location.state.item &&
                                        <Col sm={6}>
                                            <Row>
                                                <Col className="col-fit-width">
                                                    {item.isDealer === false ?
                                                        <>
                                                            <h4 className="heading mt-1">DISTRIBUTOR PRICE:</h4>
                                                            <h4 className="smaller-text mt-3">DEALER PRICE:</h4>
                                                        </>
                                                    :
                                                        <h4 className="heading mt-1">DEALER PRICE:</h4>
                                                    }
                                                   
                                                    <p className="smaller-text mt-3">MSRP:</p>
                                                </Col>

                                                <Col sm={5}>
                                                    {item.isDealer === false ? <><h4 className="heading catalog-item-price mt-1">{item.price}</h4> <h4 className="smaller-text mt-3">{item.priceForDistributorDisplay}</h4></> :
                                                        <h4 className="heading catalog-item-price mt-1">{item.price}</h4>
                                                    }
                                                   {/* <h4 className="heading catalog-item-price mt-1">{item.price}</h4>*/}
                                                    <p className="smaller-text mt-3">{item.retailPrice}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                    

                                    <Col sm={(!itemSizes || itemSizes.size === 0) && location.state.item ? 6 : 12} className="text-right mb-3">
                                        <Row>
                                            {itemSizes && itemSizes.size === 0 &&
                                                <Col className="text-right">
                                                    <div className="default-row small-input">
                                                        <h4 className="heading mt-1">Quantity</h4>
                                                        <Form.Control
                                                            type="number"
                                                            id={`qty-${item.itemNumber}`}
                                                            aria-describedby="Quantity"
                                                            className='form-control'
                                                            onBlur={handleQtyBlur}
                                                            onChange={handleQtyChange}
                                                            value={quantity}
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            <Col className="text-right">
                                                <Button variant="secondary" onClick={() => GetSKUDetail(null, false)}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    CHECK AVAILABILITY
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="border-bottom row-right">
                                    <Col sm={12} className="mb-4 text-right">
                                        <Button variant="primary" onClick={addToCart}>
                                            + ADD TO CART
                                        </Button>
                                    </Col>
                                </Row>

                                {((masterItem && masterItem.addInfo) || addInfo) &&
                                    <Row className="mt-3">
                                        <Col sm={12}>
                                            <Card>
                                                <Card.Body>
                                                    <div dangerouslySetInnerHTML={{ __html: masterItem && masterItem.addInfo ? masterItem.addInfo.extDesc : addInfo.extDesc }} />
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                }

                                {/*{itemAvailability && itemAvailability.length > 0 && itemAvailability.map((item) => (*/}
                                {/*    <Row>*/}
                                {/*        <Col sm={12} className="mb-3">*/}
                                {/*            <h4 className="bold heading">{item.item.distitemNbr}</h4>*/}

                                {/*            <Table bordered>*/}
                                {/*                <thead>*/}
                                {/*                    <tr>*/}
                                {/*                        <th>Avail <br /> Qty</th>*/}
                                {/*                        <th>CA (L)</th>*/}
                                {/*                        <th>KY (R)</th>*/}
                                {/*                        <th>TX (D)</th>*/}
                                {/*                        <th>Pkg <br /> Qty</th>*/}
                                {/*                        {item.item.boCnt > 0 && <th>BO</th>}*/}
                                {/*                    </tr>*/}
                                {/*                </thead>*/}
                                {/*                <tbody>*/}
                                {/*                    <tr>*/}
                                {/*                        <td>{item.item.qty}</td>*/}
                                {/*                        <td>{getStatusIcon(item.item.warehouseAvailColorL)}</td>*/}
                                {/*                        <td>{getStatusIcon(item.item.warehouseAvailColorR)}</td>*/}
                                {/*                        <td>{getStatusIcon(item.item.warehouseAvailColorD)}</td>*/}
                                {/*                        <td>{item.item.whslePkgCnt}</td>*/}
                                {/*                        {item.boCnt > 0 && <td>{item.item.boCnt}</td>}*/}
                                {/*                    </tr>*/}
                                {/*                </tbody>*/}
                                {/*            </Table>*/}
                                {/*        </Col>*/}
                                {/*    </Row>*/}
                                {/*))}*/}

                                {showAvailability && masterItem &&
                                    <Row>
                                        <Col sm={12} className="mt-3">
                                            {Object.keys(masterItem).length > 0 &&
                                                <Table bordered>
                                                    <thead>
                                                        <tr>
                                                            {itemSizes.size > 0 &&
                                                                <th>Item #</th>
                                                            }
                                                            <th>Avail <br /> Qty</th>
                                                            <th>CA (L)</th>
                                                            <th>KY (R)</th>
                                                            <th>TX (D)</th>
                                                            <th>Pkg <br /> Qty</th>
                                                            <th>BO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {itemSizes.size > 0 ? itemAvailability.map((item) => (
                                                            <tr>
                                                                <td>{item.item.distitemNbr}</td>
                                                                <td>{item.item.qty}</td>
                                                                <td>{getStatusIcon(item.item.warehouseAvailColorL)}</td>
                                                                <td>{getStatusIcon(item.item.warehouseAvailColorR)}</td>
                                                                <td>{getStatusIcon(item.item.warehouseAvailColorD)}</td>
                                                                <td>{item.item.whslePkgCnt}</td>
                                                                <td>{item.item.boCnt > 0 ? item.item.boCnt : '-'}</td>
                                                            </tr>
                                                            ))
                                                        :
                                                            <tr>
                                                                <td>{masterItem.item.qty}</td>
                                                                <td>{getStatusIcon(masterItem.item.warehouseAvailColorL)}</td>
                                                                <td>{getStatusIcon(masterItem.item.warehouseAvailColorR)}</td>
                                                                <td>{getStatusIcon(masterItem.item.warehouseAvailColorD)}</td>
                                                                <td>{masterItem.item.whslePkgCnt}</td>
                                                                <td>{masterItem.item.boCnt > 0 ? masterItem.item.boCnt : '-'}</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </Table>
                                            }
                                        </Col>
                                    </Row>
                                }

                                {((masterItem && masterItem.addInfo) || addInfo) &&
                                    (!itemSizes || itemSizes.size === 0) &&
                                    <Row className="mt-3">
                                        <Col sm={12}>
                                            <Card className="summary-card item-details-product-details">
                                                <Card.Body>
                                                    <Row className="green-border-bottom-thin">
                                                        <Col sm={12}>
                                                            <h3 className="heading">PRODUCT DETAILS</h3>
                                                        </Col>
                                                    </Row>

                                                    <Row className="mt-2">
                                                            <Col sm={7}>
                                                                {
                                                                    masterItem && masterItem.addInfo &&
                                                                    <>
                                                                        <p>
                                                                            <span className="bold">Vehicle Use:</span> {masterItem.addInfo.prodLinesText}
                                                                        </p>
                                                                        <p>
                                                                            <span className="bold">Model Year(s):</span> {masterItem.addInfo.yearString}
                                                                        </p>
                                                                        <p>
                                                                            <span className="bold">Eligible Exchange/Return:</span> {masterItem.addInfo.eligibleExchangeReturn}
                                                                        </p></>
                                                                 }
                                                           
                                                            <p>
                                                                <span className="bold">Dimensions (LxWxHxG) (In):</span> {masterItem && masterItem.addInfo ? masterItem.addInfo.dimentions : addInfo.dimentions}
                                                            </p>
                                                            <p>
                                                                <span className="bold">Weight (lb) / Volume (ci):</span> {masterItem && masterItem.addInfo ? masterItem.addInfo.weightVal : addInfo.weightVal}
                                                            </p>
                                                                
                                                        </Col>

                                                            <Col sm={5} className="text-right">
                                                                {masterItem && masterItem.item && <DropdownButton
                                                                    variant="dark"
                                                                    title="All Compatible models"
                                                                    className="mt-2 mb-2 item-dropdown-info"
                                                                    onClick={() => handleModelModalShow(masterItem.item.distitemNbr)}
                                                                >
                                                                </DropdownButton>}
                                               

                                                            <Col sm={12} className="mt-3">
                                                                <a href="https://www.kawasaki.com/Content/pdfs/Kawasaki_Warranty.pdf" target="_blank" rel="noreferrer" className="black-text">Warranty Statement</a>
                                                            </Col>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                }
                            </>
                            //:
                            //!loading && <Card className="summary-card item-details-product-details mt-5">
                            //    <Card.Body>
                            //        <Row className="green-border-bottom-thin">
                            //            <Col sm={12}>
                            //                <h3 className="heading">PRODUCT DETAILS</h3>
                            //            </Col>
                            //        </Row>

                            //        <Row className="mt-2">
                            //            <Col sm={12}>
                            //                <p className="bold">This item is currently unavailable. </p>
                            //            </Col>
                            //        </Row>
                            //    </Card.Body>
                            //</Card>
                              
                        }
                    </Col>
                </Row>

            </Container>

            <Modal show={imageModal} onHide={handleImageModalHide} size="lg" centered className="image-enlarge-modal">
                <Modal.Header>
                    <CloseButton variant="white" data-bs-theme="dark" className="image-close-button" onClick={handleImageModalHide} />
                </Modal.Header>
                <img src={largeImage} alt='Product' />
            </Modal>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <Modal show={showModelModal} onHide={handleModelModalClose} backdrop="static" centered dialogClassName="dealer-section model-window">
                <Modal.Header closeButton style={{ justifyContent: 'center' }}>
                    <Modal.Title>MODELS</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    {!models ?
                        <PulseLoader color="#66cc33" size="20px" margin="12px" className="mt-5" />
                        :
                        <Table bordered hover striped>
                            <thead>
                                <tr>
                                    <td colSpan="3">{selectedItemForModels && selectedItemForModels.itemNum}, {selectedItemForModels && selectedItemForModels.itemName}</td>
                                </tr>
                                {models.length > 0 && <tr>
                                    <td colSpan="3">This item fits the following models:</td>
                                </tr>}

                            </thead>
                            <tbody>
                                {models.length > 0 ? models.map((d) =>
                                    <>
                                        {d.models.map((m) =>
                                            <tr>
                                                <td>{m.year}</td>
                                                <td>{m.label}</td>
                                                <td>{m.value}</td>
                                            </tr>)}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>

                                ) :
                                    <tr>This item has no model restrictions.</tr>
                                }
                            </tbody>

                        </Table>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModelModalClose}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        CLOSE
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={popUpModal} onHide={handlePopUpModalClose} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>NOTICE</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>{popUpErrorMsg}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={12} className="text-left">
                            <Button variant="primary" onClick={handlePopUpModalClose}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                CLOSE
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <FooterDealer />
        </>
    );
}